/* eslint-disable react/jsx-props-no-spreading */
/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-06-06 20:25:12
 * @LastEditors: lxh3@meitu.com
 * @LastEditTime: 2025-06-19 14:17:36
 * @FilePath: /roboneo-web/src/components/roboneo/Tooltip/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import classNames from 'classnames';
import { Tooltip as AntdTooltip } from 'antd';
import { AbstractTooltipProps } from 'antd/es/tooltip';
import style from './index.module.scss';

interface Props extends AbstractTooltipProps {
  title: React.ReactNode;
  children: React.ReactNode;
  autoAdjustOverflow?: boolean;
  isHideToolTip?: boolean;
  overlayStyle?: React.CSSProperties;
  overlayClassName?: string;
  titleClassNames?: string;
  theme?: 'default' | 'tips';
  [key: string]: any;
}

export default function Tooltip({
  title,
  titleClassNames,
  children,
  autoAdjustOverflow = false,
  isHideToolTip = false,
  theme = 'default',
  ...props
}: Props) {
  if (isHideToolTip) return children as JSX.Element;
  return (
    <AntdTooltip
      title={(
        <div className={classNames(theme === 'tips' ? style.title_box_tips : style.title_box, titleClassNames, {
          [style.top]: !autoAdjustOverflow,
          [style.bottom]: autoAdjustOverflow,
        })}
        >
          {title}
        </div>
      )}
      color="transparent"
      autoAdjustOverflow={autoAdjustOverflow}
      mouseLeaveDelay={0}
      mouseEnterDelay={0}
      {...props}
      overlayStyle={{
        paddingBottom: '0',
        ...props.overlayStyle,
      }}
      overlayClassName={classNames(
        style.roboneo_tooltip,
        { [style.roboneo_tooltip_tips]: theme === 'tips' },
        props.overlayClassName,
      )}
    >
      {children}
    </AntdTooltip>
  );
}
